// extracted by mini-css-extract-plugin
module.exports = {"reviews":"Reviews_reviews__ud90x"};